import { createReportRepository } from './report';
import { createReportContentRepository } from './report-content';
import { createReportChapterRepository } from './chapter';
import { createReportSourceRepository } from './source';
import { createReportMentionRepository } from './mention';
import { createReportBlockRepository } from './block';
import { createFavoriteRepository } from './favorite';
import { createWorkspaceRepository } from './workspace';
import { createImportRepository } from './import';
import { createContentRepository } from './content';
import { createCollectionRepository } from './collection';
import { createTriggerRepository } from './trigger';
import { createResourceRepository } from './resource';
import { createRecordRepository } from './record';
import { createCountRepository } from './count';
import { createSuggestionRepository } from './suggestion';
import { createTaskRepository } from './task';
import { createTaskStatusRepository } from './task-status';
export function createResearchReact(config) {
    const { client, repository } = config;
    const baseConfig = {
        client,
        repository,
    };
    const record = createRecordRepository(baseConfig);
    const collection = createCollectionRepository(baseConfig);
    const resource = createResourceRepository(baseConfig);
    return {
        report: createReportRepository(baseConfig),
        chapter: createReportChapterRepository(baseConfig),
        reportContent: createReportContentRepository(baseConfig),
        source: createReportSourceRepository(baseConfig),
        mention: createReportMentionRepository(baseConfig),
        block: createReportBlockRepository({
            ...baseConfig,
            record,
            collection,
            resource,
        }),
        favorite: createFavoriteRepository(baseConfig),
        workspace: createWorkspaceRepository(baseConfig),
        import: createImportRepository(baseConfig),
        content: createContentRepository(baseConfig),
        collection: collection,
        trigger: createTriggerRepository(baseConfig),
        resource: resource,
        record: record,
        count: createCountRepository(baseConfig),
        suggestion: createSuggestionRepository(baseConfig),
        task: createTaskRepository(baseConfig),
        taskStatus: createTaskStatusRepository(baseConfig),
    };
}
//# sourceMappingURL=reactProvider.js.map